import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly themeController = new BehaviorSubject<'dark' | 'light'>('dark');
  readonly theme$: Observable<'dark' | 'light'> = this.themeController.asObservable();

  constructor() {
    const currentTheme = localStorage.getItem('hs_theme') || 'dark';

    if (currentTheme === 'dark' || currentTheme === 'light') {
      this.themeController.next(currentTheme);
    }
  }

  changeTheme(theme: 'dark' | 'light'): void {
    this.themeController.next(theme);
  }
}
